export const removeForeignKeyFromId = (id: string): string => id.replace(/^(fk-)/, '')
